// 한글 조사(이/가·와/과) 선택 — 앱 shared/utils/ko_josa.dart 와 같은 규칙.
// 문구(locales)에는 조사를 넣지 않고 이름 자리 값에 조사를 붙여 넘긴다.
// 마지막 글자가 한글 음절이면 받침 유무로, 그 외(영문·숫자·빈 값)는 받침 없음으로 본다.

/// word 끝 글자에 받침이 있으면 withFinal, 없으면 withoutFinal (조사만).
export function koJosa(word, withFinal, withoutFinal) {
  var w = String(word == null ? '' : word).replace(/\s+$/, '');
  if (!w) return withoutFinal;
  var code = w.charCodeAt(w.length - 1);
  if (code < 0xAC00 || code > 0xD7A3) return withoutFinal;
  return (code - 0xAC00) % 28 !== 0 ? withFinal : withoutFinal;
}

/// locale 이 'ko' 일 때만 word 뒤에 조사를 붙인다. 다른 언어는 word 그대로.
export function withKoJosa(locale, word, withFinal, withoutFinal) {
  return locale === 'ko' ? word + koJosa(word, withFinal, withoutFinal) : word;
}
